// PRODUCT TERM

import {
  DEFAULT_VIVUS_ONLINE_TERM,
  EMAIL_VIVUSONLINE,
  LOGIN_VIVUS_ONLINE_PATH,
  PHONE_LINK_VIVUSONLINE,
  PHONE_VIVUSONLINE,
} from 'utils/constants/constants_vivusonline';
import {
  DEFAULT_VIVUS_TERM,
  EMAIL_VIVUS,
  IS_VIVUS,
  LOGIN_VIVUS_PATH,
  PHONE_LINK_VIVUS,
  PHONE_VIVUS,
} from './constants_vivus';

export const DEFAULT_AMOUNT = 280;

export const DEFAULT_TERM = IS_VIVUS
  ? DEFAULT_VIVUS_TERM
  : DEFAULT_VIVUS_ONLINE_TERM;

// PHONE + EMAILS

export const PHONE_SUPPORT = '91 290 77 88';
export const PHONE_LINK_SUPPORT = '+34912907788';

export const PHONE = IS_VIVUS ? PHONE_VIVUS : PHONE_VIVUSONLINE;
export const PHONE_LINK = IS_VIVUS ? PHONE_LINK_VIVUS : PHONE_LINK_VIVUSONLINE;

export const EMAIL = IS_VIVUS ? EMAIL_VIVUS : EMAIL_VIVUSONLINE;

export const BUSINESS_HOURS =
  'Lunes – Viernes / 8:00 – 21:00, Sábado / 9:00 – 20:00, Festivos nacionales / 9:00 – 14:00';

// DASHBOARD ROUTES

export const LOGIN_PATH = IS_VIVUS ? LOGIN_VIVUS_PATH : LOGIN_VIVUS_ONLINE_PATH;

export const DASHBOARD_URL =
  process.env.REACT_APP_DASHBOARD_URL || 'https://account.vivus.es';

export const LOGIN_ROUTE = `${DASHBOARD_URL}${LOGIN_PATH}`;

// DASHBOARD ROUTES

export const URL_PATH =
  process.env.REACT_APP_CALCULATOR || 'https://www.vivus.es';
const PATH_CONDITIONS = IS_VIVUS ? `${URL_PATH}/condiciones` : URL_PATH;

export const URL_TERMS_CONDITIONS = IS_VIVUS
  ? `${PATH_CONDITIONS}/generales`
  : `${PATH_CONDITIONS}/condiciones-generales`;

export const URL_MARKETING = `${PATH_CONDITIONS}/marketing-y-comunicacion`;
export const URL_COMMUNICATIONS = `${PATH_CONDITIONS}/comunicaciones-a-terceros`;
export const URL_PRIVACY = `${PATH_CONDITIONS}/politica-de-privacidad`;
export const URL_CESCO = 'https://www.vivus.es/prestamos-responsables';
export const URL_GENERAL_CONDITIONS = IS_VIVUS
  ? `${PATH_CONDITIONS}/generales`
  : `${URL_PATH}/condiciones-generales`;

// SESSION

export const SESSION_MOBILE_INSTANCE_ID = 'mobile_app_instance_id';

// JUICY

export const JUICY_NEXT_BTN = 'juicyNextButton';
export const JUICY_PING_BTN = 'juicyPingButton';
export const JUICY_COMPLETE_BTN = 'juicyCompleteButton';

export const SESSION_TINK_REASON = 'tinkReason';

// MOBILE APP
export const MOBILE_APP_LOGIN = 'vivuses://guest/signin';
export const MOBILE_APP_GUEST = 'vivuses://guest';
export const EMBEDDED_IN_WEBVIEW_PARAM = 'embedded_in_webview';
export const MOBILE_SOURCE_PARAM = 'source';

// QUERY PARAMETERS

export const ERROR_QUERY_PARAM = 'r';
